<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>

        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="username"
                  label="Username"
                  v-model="user.username"
                  type="text"
                  :disabled="user.id ? true : false"
                  :rules="[
                                                        () => !!user.username || 'Username is required',
                                                    ]"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!user.id">
                <v-text-field
                  name="password"
                  label="Password"
                  v-model="user.password"
                  type="password"
                  :rules="[
                                                        () => !!user.password || 'Password is required',
                                                    ]"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="!user.id">
                <v-text-field
                  name="confirmPassword"
                  label="Confirm Password"
                  v-model="user.confirmPassword"
                  type="password"
                  :rules="[
                                                        () => !!user.confirmPassword || 'Confirm Password is required',
                                                        ()=> user.password == user.confirmPassword || 'Password and confirm password does not match'
                                                    ]"
                ></v-text-field>
              </v-flex>

              <v-flex sm12>
                <v-select
                  :disabled="user.id ? true : false"
                  :items="roleNameList"
                  v-model="user.roleName"
                  label="Select role name"
                  :rules="[
                    () => !!user.roleName || 'Role Name is required'
                    ]"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="user.roleName && user.roleName == 'WAREHOUSE_MANAGER'">
                <v-select
                  :items="warehouseList"
                  v-model="user.warehouseId"
                  label="Select Warehouse"
                  item-text="name"
                  item-value="id"
                  :rules="[
                    () => !!user.warehouseId || 'Warehouse is required'
                    ]"
                ></v-select>
              </v-flex>
              <v-flex
                sm12
                v-if="user.roleName && (user.roleName == 'SALE_MANAGER' || user.roleName == 'SALE' || user.roleName == 'SALE_PERSON' )"
              >
                <v-select
                  :items="shopList"
                  v-model="user.shopId"
                  label="Select Shop"
                  item-text="name"
                  item-value="id"
                  :rules="[
                    () => !!user.shopId || 'Shop is required'
                    ]"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="user.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="user.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="user.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="user.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="user.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="user.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex sm6 v-if="user.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm6 v-if="user.id">
                <v-btn
                  flat
                  color="primary"
                  @click="showChangePwdModal()"
                  style="float:right"
                >Change Password?</v-btn>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!----------------- For Change Password Dialog --------------------->

    <v-dialog v-model="openDialog" persistent max-width="350">
      <v-form ref="modalForm" v-model="modalValid" lazy-validation @submit.prevent="changePassword">
        <v-card>
          <v-card-title primary-title class="headline blue darken-2">
            <span class="white--text">Change Password</span>
          </v-card-title>
          <v-divider></v-divider>
          <div class="ma-3">
            <v-flex sm12>
              <v-text-field
                name="username"
                label="Username"
                v-model="modalUser.username"
                type="text"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                name="password"
                label="Password"
                v-model="modalUser.password"
                type="password"
                :rules="[
                    () => !!modalUser.password || 'Password is required',
                    () => modalUser.password && modalUser.password.length > 6 || 'Password length must be greater than 6 characters'
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex sm12>
              <v-text-field
                name="confirmPassword"
                label="Confirm Password"
                v-model="modalUser.confirmPassword"
                type="password"
                :rules="[
                                                        () => !!modalUser.confirmPassword || 'Confirm Password is required',
                                                        ()=> modalUser.password == modalUser.confirmPassword || 'Password and confirm password does not match'
                                                    ]"
              ></v-text-field>
            </v-flex>
          </div>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click.native="openDialog = false">Cancel</v-btn>
            <v-btn color="primary" flat type="submit">Change Password</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { userService } from "../../services/user-service";
import { User } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { warehouseService } from "../../services/warehouse-service";
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";

export default {
  name: "UserDetail",
  components: { VSwitch },
  data: () => ({
    openDialog: false,
    valid: true,
    modalValid: true,
    breadcrumbs: [
      {
        text: "Users",
        disabled: false,
        to: "users"
      },
      {
        text: "User Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    user: new User(),
    oldUser: new User(),
    statusFlag: true,
    roleNameList: [],
    warehouseList: [],
    shopList: [],
    saveLoading: false,
    responseError: "",
    modalError: "",
    modalUser: new User()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new user
    } else {
      this.getUserDetail(id);
    }

    this.getAllRoles();
    this.getAllWarehouses();
    this.getAllShop();
  },
  methods: {
    changePassword() {
      if (this.$refs.modalForm.validate()) {
        userService
          .changePasswordById(this.modalUser)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    showChangePwdModal() {
      this.$refs.modalForm.resetValidation();
      this.openDialog = true;
      this.modalUser.username = this.user.username;
      this.modalUser.id = this.user.id;
    },
    getAllRoles() {
      userService
        .getAllRoles()
        .then(res => {
          let roleList = res.data;
          for (let role of roleList) {
            this.roleNameList.push(role.roleName);
          }
          console.log("RoleNameList" + this.roleNameList);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
          console.log(JSON.stringify(this.warehouseList));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserDetail(id) {
      userService
        .getUserDetail(id)
        .then(res => {
          this.user = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.user.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.user.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldUser = Object.assign({}, res.data);
          this.statusFlag = this.user.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.user.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let userObj = {
          id: this.user.id ? this.user.id : "",
          username: this.user.username,
          password: this.user.password,
          roleName: this.user.roleName,
          warehouseId: this.user.warehouseId,
          warehouseName: this.user.warehouseName,
          shopId: this.user.shopId,
          status: this.user.status
        };
        userService
          .saveUser(userObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.user.id) {
        this.user = new User();
        this.statusFlag = true;
      } else {
        this.user = Object.assign({}, this.oldUser);
        this.statusFlag = this.user.status == "ACTIVE" ? true : false;
      }

      this.responseError = "";
    },
    goBack() {
      this.$router.push("/users");
    }
  }
};
</script>

<style scoped>
</style>